const moneyFormat = document.currentScript.getAttribute('money-format') || "${{amount}}";
//const baseAppProxy = '/apps/shopqse-3d-ring-creator';
const baseAppProxy = 'https://phpstack-1090158-4665907.cloudwaysapps.com';
const swatches_static_data = {
    "14k white gold": {
        "color": "swatch-white",
        "short_name": "14K",
    },
    "14k yellow gold": {
        "color": "swatch-yellow",
        "short_name": "14K",
    },
    "14k rose gold": {
        "color": "swatch-rose",
        "short_name": "14K",
    },
    "18k white gold": {
        "color": "swatch-white",
        "short_name": "18K",
    },
    "18k yellow gold": {
        "color": "swatch-yellow",
        "short_name": "18K",
    },
    "18k rose gold": {
        "color": "swatch-rose",
        "short_name": "18K",
    },
    "platinum": {
        "color": "swatch-white",
        "short_name": "PL",
    },
    "14k white/yellow": {
        "color": "swatch-white-yellow",
        "short_name": "14K WY",
    },
    "14k white/rose": {
        "color": "swatch-white-rose",
        "short_name": "14K WR",
    },
    "14k yellow/rose": {
        "color": "swatch-yellow-rose",
        "short_name": "14K YR",
    },
    "18k white/yellow": {
        "color": "swatch-white-yellow",
        "short_name": "18K WY",
    },
    "18k white/rose": {
        "color": "swatch-white-rose",
        "short_name": "18K WR",
    },
    "18k yellow/rose": {
        "color": "swatch-yellow-rose",
        "short_name": "18K YR",
    },
    "14k yellow/white": {
        "color": "swatch-yellow-white",
        "short_name": "14K YW",
    },
    "14k rose/white": {
        "color": "swatch-rose-white",
        "short_name": "14K RW",
    },
    "18k rose/white": {
        "color": "swatch-rose-white",
        "short_name": "18K RW",
    },
    "18k rose/yellow": {
        "color": "swatch-rose-yellow",
        "short_name": "18K RY",
    },
    "18k yellow/white": {
        "color": "swatch-yellow-white",
        "short_name": "18K WY",
    }
};

function formatMoneyForCollections(cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};

function matchWordFromString(inputString, word) {
    const regex = new RegExp(`[^a-zA-Z0-9]*(${word})[^a-zA-Z0-9]*`);
    const match = inputString.match(regex);
    if (match) {
        return match[1];
    }
    return ''; // Return empty string if the word is not found
};

function getUrlParameterForCollection(sParam, isMulti = false) {
    var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split("&"), sParameterName, i;
    var paramValues = []; // Array to store multiple values of the same param
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split("=");
        if (sParameterName[0] === sParam) {
            var value = sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            paramValues.push(value); // Add each occurrence to the array
        }
    }

    // Return array if multiple values, otherwise return single value or undefined
    if (isMulti == true) {
        if (paramValues.length > 1) {
            return paramValues.join(',');
        } else if (paramValues.length === 1) {
            return paramValues[0];
        } else {
            return undefined;
        }
    } else {
        if (paramValues.length > 0) {
            return paramValues[0];
        } else {
            return undefined;
        }
    }
};

async function loadMetalWhenSelected() {
    const variantSwatchesItemSelectedElements = Array.from(document.getElementsByClassName('variant-swatches-item-selected'));
    const metalParam = getUrlParameterForCollection('filter.p.m.custom.metal').replaceAll('+', ' ');
    variantSwatchesItemSelectedElements.forEach(async function (element) {
        if (element?.dataset?.metalValue == metalParam) {
            element.click();
        }
    });
}

async function reRefreshSwatchEvents() {
    const variantSwatchesItemSelectedElements = Array.from(document.getElementsByClassName('variant-swatches-item-selected'));
    if (variantSwatchesItemSelectedElements?.length > 0) {
        variantSwatchesItemSelectedElements.forEach(async function (element) {
            element.addEventListener('click', async function (e) {
                const _this = this, _parentElement = _this.parentElement;

                document.getElementById(`product-loader-${_parentElement?.dataset?.productHandle}`) && (document.getElementById(`product-loader-${_parentElement?.dataset?.productHandle}`).classList.add('loader--active'));
                try {
                    var formData = new FormData();
                    formData.append("action", "fetch_all_data_for_collection_webgi_based_on_attr");
                    formData.append("shop", Shopify.shop);
                    formData.append("product_title", _parentElement?.dataset?.configuratorName);
                    formData.append("selected_attribute_info", _this?.dataset?.metalValue);
                    formData.append("shape", _parentElement?.dataset?.productShape);
                    formData.append("product_handle", _parentElement?.dataset?.productHandle);
                    await fetch(`${baseAppProxy}/frontend.php`, {
                        method: 'POST',
                        body: formData
                    })
                    .then(response => response.json())
                    .then(result => {
                        if (result?.SUCCESS === "TRUE") {
                            if (Object.keys(result?.DATA)?.length > 0) {
                                const noImage = `${baseAppProxy}/images/no-image.png`;
                                const handle = _parentElement.dataset.productHandle;
                                const prodInfoData = result?.DATA;
                                const queryString = window.location.search;
                                const collection_path = location.pathname;
                                
                                document.querySelectorAll(`[data-card-title="${handle}"]`) && (document.querySelectorAll(`[data-card-title="${handle}"]`).innerHTML = prodInfoData?.title);
                                if (Array.from(document.querySelectorAll(`[data-card-link="${handle}"]`))?.length > 0) {
                                    Array.from(document.querySelectorAll(`[data-card-link="${handle}"]`)).forEach(e => e.setAttribute('href', `${collection_path}/products/${prodInfoData?.handle}${queryString}`));
                                }
                                if (Array.from(document.querySelectorAll(`[data-card-price="${handle}"]`))?.length > 0) {
                                    Array.from(document.querySelectorAll(`[data-card-price="${handle}"]`)).forEach(e => e.innerHTML = formatMoneyForCollections(Number(prodInfoData?.price) * 100));
                                }
                                if (document.querySelector(`[data-card-image="${handle}"]`)) {
                                    const cartImageElement = document.querySelector(`[data-card-image="${handle}"]`);
                                    const productImage = prodInfoData?.image != null ? prodInfoData?.image : noImage;
                                    
                                    cartImageElement.setAttribute('src', productImage);
                                    cartImageElement.setAttribute('srcset', productImage);
                                }

                                setTimeout(function() {
                                  document.getElementById(`product-loader-${handle}`) && (document.getElementById(`product-loader-${handle}`).classList.remove('loader--active'));
                                }, 1000);
                            }
                        }
                    })
                    .catch(error => error);
                } catch (error) {
                    console.log({ error });
                }
            });
        });
        getUrlParameterForCollection('filter.p.m.custom.metal')?.length > 0 && (await loadMetalWhenSelected());
    }
}

async function onLoadSwatchCollectionSelected() {
    const swatchCollectionSelectedActiveElements = Array.from(document.getElementsByClassName('collections-variant-swatches-selector'));
    if (swatchCollectionSelectedActiveElements?.length > 0) {
        let products = [];
        swatchCollectionSelectedActiveElements.forEach(async function (element) {
            if (element?.dataset?.configuratorName?.length > 0) {
                products.push({
                    title: element?.dataset?.configuratorName,
                    handle: element?.dataset?.productHandle,
                    shape: element?.dataset?.productShape
                });
            }
        });

        if (products?.length > 0) {
            try {
                var formData = new FormData();
                formData.append("action", "fetch_all_data_for_collection_webgi");
                formData.append("shop", Shopify.shop);
                formData.append("products", JSON.stringify(products));
                await fetch(`${baseAppProxy}/frontend.php`, {
                    method: 'POST',
                    body: formData
                })
                .then(response => response.json())
                .then(result => {
                    if (result?.SUCCESS === "TRUE") {
                        const collectionProdInfoData = result?.DATA;
                        if (Object.keys(collectionProdInfoData)?.length > 0) {
                            const collectionKeys = Object.keys(collectionProdInfoData);
                            collectionKeys.forEach(function (key) {
                                const collectionProdInfo = collectionProdInfoData[key];
                                if (collectionProdInfo?.length > 0) {
                                    const collectionProdInfoHtml = collectionProdInfo.map(function (item) {
                                        const metal = item.toLocaleLowerCase().includes('platinum') ? 'platinum' : item.toLocaleLowerCase();
                                        return `<li class="variant-swatches-item-selected variant-swatches--item ${swatches_static_data[metal]?.color}" data-metal-value="${item}">${swatches_static_data[metal]?.short_name}</li>`;
                                    });
                                    const collectionProdInfoElement = document.querySelector(`.collections-variant-swatches-selector[data-product-handle="${key}"]`);
                                    collectionProdInfo?.length > 7 && (collectionProdInfoElement.classList.add('variant-swatches--list-overflow'));
                                    collectionProdInfoElement.innerHTML = collectionProdInfoHtml.join('');
                                }
                            });
                            reRefreshSwatchEvents();
                        }
                    }
                })
                .catch(error => error);
            } catch (error) {
                console.log({ error });
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", async () => await onLoadSwatchCollectionSelected());